"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutationObserver = void 0;
const react_1 = require("react");
const useMutationObserver = (ref, handler, options = {
    characterData: true,
    childList: true,
    subtree: true,
}) => {
    (0, react_1.useEffect)(() => {
        if (!handler || !ref.current) {
            return undefined;
        }
        const mutationObserver = new MutationObserver(handler);
        mutationObserver.observe(ref.current, options);
        return () => {
            mutationObserver.disconnect();
        };
    }, [handler, options, ref]);
};
exports.useMutationObserver = useMutationObserver;
//# sourceMappingURL=index.js.map